import React from "react";

function ApplicableProductTable({ products }: any) {
  return (
    <div className="relative overflow-x-auto">
      <table className="min-w-[400px] w-full table-auto text-sm ml:text-base">
        <thead>
          <tr className="border-b border-[#EEEFF2]">
            <th className="py-4 px-4 font-normal text-left text-base-300">Product Id</th>
            <th className="py-4 px-4 font-normal text-left text-base-300">Product Name</th>
          </tr>
        </thead>
        <tbody>
          {products.map((product: any, index: number) => (
            <tr className="border-b border-[#EEEFF2] font-semibold" key={index}>
              <td className="text-left py-3 px-4">{product.product.id}</td>
              <td className="text-left py-3 px-4">{product.product.name}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default ApplicableProductTable;
